<template>
  <div id="app" class="app-wrapper">
    <main id="app-content" class="main-content-align">
      <div class="main-logo-wrapper">
        <!--<img alt="Company Logo" src="./assets/logo.png" class="main-logo-img">-->
      </div>
      <router-view/>
    </main>
    <footer class="site-footer">
      <div class="gobeyonddev-footer-logo-container">
        <router-link to="/" class="footer-gobeyonddev-link">
          <img src="@/assets/GoBeyond-footer-logo.svg" alt="GoBeyondDev Logo" class="gobeyonddev-logo" />
        </router-link>
      </div>
      &copy; 2026 GoBeyond Software Development
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  background: #fff;
  color: #000;
}
body {
  min-height: 100vh;
  width: 100vw;
  color: #000;
}
.app-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-logo-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0 0 0;
}
#app-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  min-height: 100vh;
  box-sizing: border-box;
}
.site-footer {
  margin-top: auto;
  padding: 10px 0 0 0;
  text-align: center;
  color: #888;
  font-size: 0.95em;
  background: transparent;
  margin-bottom: 16px;
}
.gobeyonddev-footer-logo-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0 10px 0;
}
.footer-gobeyonddev-link {
  display: inline-flex;
  align-items: center;
}
.gobeyonddev-logo {
  height: 141px;
  width: auto;
  display: block;
}
@media (max-width: 700px) {
  .gobeyonddev-logo {
    max-width: 105px;
    width: 53vw;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }
  .gobeyonddev-footer-logo-container {
    margin: 18px 0 0 0;
  }
}
</style>
